<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>历史退费单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="display:flex;align-items: center">
      <el-date-picker
        v-model="orderRequest.selectDate"
        type="daterange"
        range-separator="至"
        size="mini"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="selectKpiData"
        value-format="yyyy-MM-dd"
        style="margin-left: 5px;"
      >
      </el-date-picker>
      <el-button size="mini"  style="margin-left: 5px;" @click="queryRefund">查询</el-button>
      <el-button size="mini"  style="margin-left: 5px;" @click="showOldOrderRefund">新建散客退费单</el-button>
    </div>
    <span style="color: #3a8ee6;font-size: 13px;margin-right: 100px">总计退费：{{zjAmount}}</span>
    <el-table height="510px" :data="refundList" fit border stripe="stripe" :header-cell-style="{background:'#eff3f8', color:'#333'}"
              :row-style="{height: '0'}">
      <el-table-column
        prop="refundDate"
        label="退费日期"
        align="center">
      </el-table-column>
      <el-table-column
        prop="consumptionName"
        label="消费项目"
        align="center">
      </el-table-column>
      <el-table-column
        prop="money"
        label="退费金额"
        align="center">
      </el-table-column>
      <el-table-column
        prop="num"
        label="退还数量"
        align="center">
      </el-table-column>
      <el-table-column
        prop="refundType"
        label="退费方式"
        align="center"
        :formatter="refundTypeFormatter">
      </el-table-column>
      <el-table-column
        prop="orderId"
        label="所属消费单号"
        align="center">
      </el-table-column>
      <el-table-column
        prop="serverName"
        label="服务人员"
        align="center">
      </el-table-column>
      <el-table-column
        align="center"
        label="备注说明"
        width="250">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>{{ scope.row.comment }}</p>
            <div slot="reference" class="name-wrapper">
              <el-tag size="mini">{{ scope.row.comment }}</el-tag>
            </div>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>


    <!-- 消费单退费窗口-->
    <el-dialog
      title="新建历史散客消费单退费"
      :visible.sync="oldOrderRefundDialogVisible"
      width="60%"
      @close="closeOldOrderRefundDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-card class="box-card">
        <div style="display: flex;justify-content: space-evenly;align-items:center;width: 100%;">
          <div>
            <label style="color: #FA5858">*</label>
            <span style="width: 10%;">消费单号：</span>
            <el-input v-model="oldRefundOrder.orderId"  placeholder="请输入内容" size="mini" style="width: 200px;"
                      onkeyup="value=value.replace(/[^\d]/g,'')" @change="checkOldOrderIdExist"/>
          </div>
          <div>
            <label style="color: #FA5858">*</label>
            <span style="width: 10%;">消费项目：</span>
            <el-input v-model="oldRefundOrder.consumptionName"  placeholder="请输入内容" size="mini" style="width: 200px" />
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <div style="display: flex;justify-content: space-evenly;align-items:center;width: 100%;">
          <div>
            <label style="color: #FA5858">*</label>
            <span >应退金额：</span>
            <el-input v-model="oldRefundOrder.yingtui"  size="mini" style="width: 50%;"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"
            />
          </div>
          <div>
            <label style="color: #FA5858">*</label>
            <span >实退金额：</span>
            <el-input v-model="oldRefundOrder.shitui"  size="mini" style="width: 50%;"
                      onkeyup="value=value.replace(/[^\d.]/g,'')"
            />
          </div>
          <div>
            <label style="color: #FA5858">*</label>
            <span style="width: 10%;">退还数量：</span>
            <el-input v-model="oldRefundOrder.refundNum"  placeholder="请输入内容" size="mini" style="width: 50%;"
                      onkeyup="value=value.replace(/[^\d]/g,'')"
            />
          </div>
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 10px">
        <label style="color: #FA5858">*</label>
        <span>备注说明：</span>
        <el-input v-model="oldRefundOrder.comment"  placeholder="请输入内容" type="textarea" size="mini" style="width: 100%;" />
      </el-card>

      <span class="dialog-footer">
        <el-button size="mini" @click="closeOldOrderRefundDialog">取 消</el-button>
        <el-button size="mini" @click="createRefundOrder">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      userId:'',
      currentOrgId:'',
      refundList:[],
      currentPage: 1,
      pageSize:20,
      pageTotal:0,
      zjAmount:'',
      orderStateText:[
        {detailState:1,name:'已退费'},
        {detailState:2,name:'已作废'}
      ],
      refundTypeText:[
        {refundType:1,name:'会员余额'},
        {refundType:2,name:'现金'}
      ],
      orderRequest:{
        orgId: '',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        selectDate:''
      },
      oldRefundOrder:{
        consumptionName:'',
        yingtui:'',
        shitui:'',
        refundNum:'',
        orderId:'',
        comment:'',
        orgId:'',
        creator:''
      },
      oldOrderRefundDialogVisible: false,
    }
  },
  methods:{
    refundTypeFormatter(row){
      let value = "";
      for (let i = 0; i < this.refundTypeText.length; i++){
        let item = this.refundTypeText[i];
        if (row.refundType === item.refundType) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    async loadRefundCount(){
      if (this.orderRequest.selectDate === ''){
        this.orderRequest.startDate = this.getCurrentMonthFirst();
        this.orderRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }

      this.orderRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/count/old/refund/order`, this.orderRequest)
      if (res.code === 200){
        this.pageTotal = res.totalPage;
      }
    },
    async loadRefundList(){
      this.orderRequest.pageNum = this.currentPage;
      this.orderRequest.pageSize = this.pageSize;
      this.orderRequest.orgId = this.currentOrgId;
      if (this.orderRequest.selectDate === ''){
        this.orderRequest.startDate = this.getCurrentMonthFirst();
        this.orderRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
      const {data:res} = await this.$http.post(`/load/old/refund/order`, this.orderRequest)
      if (res.code === 200){
        this.refundList = res.data;
      }
    },
    async loadRefundAmount(){
      this.orderRequest.pageNum = this.currentPage;
      this.orderRequest.pageSize = this.pageSize;
      this.orderRequest.orgId = this.currentOrgId;
      if (this.orderRequest.selectDate === ''){
        this.orderRequest.startDate = this.getCurrentMonthFirst();
        this.orderRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
      const {data:res} = await this.$http.post(`/amount/old/order/refund`, this.orderRequest)
      if (res.code === 200){
        this.zjAmount = res.data;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadRefundList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadRefundList();
    },
    getCurrentMonthFirst () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthLast () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = new Date(year, month, 0)
      return year + '-' + month + '-' + day.getDate()
    },
    selectKpiData(){
      if (this.orderRequest.selectDate === null){
        this.orderRequest.startDate = this.getCurrentMonthFirst();
        this.orderRequest.endDate = this.getCurrentMonthLast();
      } else {
        this.orderRequest.startDate = this.orderRequest.selectDate[0];
        this.orderRequest.endDate = this.orderRequest.selectDate[1];
      }
    },
    queryRefund(){
      this.loadRefundCount();
      this.loadRefundList();
      this.loadRefundAmount();
    },
    showOldOrderRefund(){
      this.clearOldRefund();
      this.oldOrderRefundDialogVisible = true;
    },
    closeOldOrderRefundDialog(){
      this.oldOrderRefundDialogVisible = false;
    },
    async createRefundOrder(){
      this.oldRefundOrder.orgId = this.currentOrgId;
      this.oldRefundOrder.creator = this.userId;
      if(this.oldRefundOrder.orderId === ''){
        return this.$message.warning("请填写消费单号！");
      }
      if(this.oldRefundOrder.orderId.length > 10){
        return this.$message.warning("消费单号不能超过10位数！");
      }
      if(this.oldRefundOrder.consumptionName === ''){
        return this.$message.warning("请填写消费项目！");
      }
      if(this.oldRefundOrder.yingtui === ''){
        return this.$message.warning("请填写应退金额！");
      }
      if(this.oldRefundOrder.yingtui.length > 8){
        return this.$message.warning("应退金额不能超过8位数！");
      }
      if(this.oldRefundOrder.shitui === ''){
        return this.$message.warning("请填写实退金额！");
      }
      if((this.oldRefundOrder.shitui - 0) > (this.oldRefundOrder.yingtui -0)){
        return this.$message.warning("实退金额不能大于应退金额！");
      }
      if(this.oldRefundOrder.refundNum === ''){
        return this.$message.warning("请填写退还数量！");
      }
      if(this.oldRefundOrder.comment === ''){
        return this.$message.warning("请填写备注说明！");
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/sk/order/refund/old`, this.oldRefundOrder)
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      this.queryRefund();
      this.closeOldOrderRefundDialog();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    clearOldRefund(){
      this.oldRefundOrder.refundNum='';
      this.oldRefundOrder.comment='';
      this.oldRefundOrder.consumptionName='';
      this.oldRefundOrder.orderId='';
      this.oldRefundOrder.shitui='';
      this.oldRefundOrder.yingtui='';
    },
    //检查消费单号是否存在
    async checkOldOrderIdExist(){
      const {data:res} = await this.$http.get(`/sk/order/refund/old/orderId/${this.oldRefundOrder.orderId}`)
      let count = res.data;
      if (count > 0){
        this.oldRefundOrder.orderId = '';
        return this.$message.warning("该消费单号已经存在，请重新填写！");
      }
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.queryRefund();
  }
}
</script>

<style lang="less" scoped>

.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__body{
  padding: 10px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/OldOrderRefund.vue